<template>
  <div>
    <span @click="click" style="cursor: pointer" class="ui-text-clickable">{{
      displayText
    }}</span>
    <hi-dialog
      v-model="isOpen"
      title="Select Projects to Display"
      @submit="submit"
      submit-txt="OK"
    >
      <hi-flat-selection
        :items="projects"
        item-text="label"
        multiple
        ref="selector"
        :selected-items="selected"
      ></hi-flat-selection>
    </hi-dialog>
  </div>
</template>

<script>
import HiDialog from "@/components/HiDialog";
import HiFlatSelection from "@/components/HiFlatSelection";
import { meta } from "@/db";
export default {
  name: "DLProjectSelectorMultiple",
  components: { HiFlatSelection, HiDialog },
  props: {
    localId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      projects: null,
      isOpen: false,
      selected: [],
      isAllSelected: false
    };
  },
  methods: {
    click() {
      this.isOpen = true;
    },
    submit() {
      const val = this.$refs.selector.getValue();
      ///save to localstorage
      if (val === "all") {
        localStorage.setItem(this.localId + "-projectSelectorMultiple", "all");
        this.isAllSelected = true;
      } else {
        localStorage.setItem(
          this.localId + "-projectSelectorMultiple",
          JSON.stringify(val)
        );
        this.selected = val;
        this.isAllSelected = false;
      }

      this.$emit("select", val);
      this.isOpen = false;
    }
  },
  async created() {
    this.projects = await meta.projects();
    // console.log(this.projects);
    // console.log(this.sources);
  },
  mounted() {
    let projects = localStorage.getItem(
      this.localId + "-projectSelectorMultiple"
    );
    if (!projects || !projects.length) {
      projects = "all";
    }
    if (projects !== "all") {
      projects = JSON.parse(projects);
    }
    if (!projects.length) {
      projects = "all";
    }
    // this.$refs.selector.setValue(projects);
    if (projects === "all") {
      this.selected = [];
      this.isAllSelected = true;
    } else {
      this.selected = projects.slice();
    }

    this.$emit("select", projects);
    // localStorage.setItem("employees", JSON.stringify(employees));
    // var storedNames = JSON.parse(localStorage.getItem("employees"));
  },
  computed: {
    displayText() {
      if (this.isAllSelected) {
        return "Projects: ALL";
      } else {
        if (!this.selected || !this.selected.length) {
          return "Select Projects";
        }
        let text = "Projects: ";
        for (let i = 0; i < this.selected.length; i++) {
          const v = this.selected[i];
          if (i !== 0) {
            text += " ,";
          }
          text += v;
        }
        return text;
      }
    }
  }
};
</script>

<style scoped></style>
